import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var EstimateErrorResponse = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment estimateError on EstimateErrorResponse {\n    status\n    uuid\n    error\n    message\n  }\n"])));
export default EstimateErrorResponse;